import store from "./../store.js";

export const generateUUID = () => {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    return (
        s4() +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        s4() +
        s4()
    );
};

export const getUrlWebSocket = (ip, guid) => {
    return "wss://" + ip + "/websockets/webmessages/" + guid;
};

//metodos
export const unifiedInboxNotification = (
    titleText,
    bodyText,
    method,
    image
) => {
    if (typeof Notification !== "undefined" && typeof Notification !== "null") {
        if (store.state.notifications.notifications) {
            if (Notification.permission === "granted") {
                let noty = navigator.serviceWorker.ready.then(registration => {
                    registration.showNotification(titleText, {
                        body: bodyText,
                        icon: image,
                        vibrate: [200, 100, 200, 100, 200, 100, 200],
                        tag: "vibration-sample",
                        dir: "ltr", // or ltr, rtl
                        lang: "en" //lang used within the notification
                    });
                });
                noty.onclick = function () {
                    window.focus();
                    noty.close();
                    method();
                };
            } else {
                window.parent.postMessage({ action: 'REQUEST_NOTIFICATION_PERMISSION' }, "*");
            }
        }
    }
};

export const getNavigatorLanguage = () => {
    let arr = ["en", "es", "pt", "bn", "lv", "it"];
    let lang = window.navigator.language.split("-")[0];

    for (let i = 0; i < arr.length; i++) {
        if (arr[i] === lang) return lang;
    }

    //por defecto ingles
    return "en";
};

export const styleMessage = (message) =>{
    //Remplazo asteriscos por Negrita <b>, Verguilla por Italic <i>, guion bajo por Subrayado <del>
    //y comilla griega por monospace <span style="font-family:monspace">
    return message.replace(/(\s[*])(.*?)([*]\s)/g, " <b>$2</b> ").replace(/(^[*])(.*?)([*]$)/g, "<b>$2</b>")
    .replace(/(\s[*])(.*?)([*]$)/g, " <b>$2</b>").replace(/(^[*])(.*?)([*]\s$)/g,"<b>$2</b> ")
    .replace(/(^[_])(.*?)([_]$)/g, "<i>$2</i>").replace(/(\s[_])(.*?)([_]\s)/g, " <i>$2</i> ")
    .replace(/(\s[_])(.*?)([_]$)/g, " <i>$2</i>").replace(/(^[_])(.*?)([_]\s$)/,"<i>$2</i> ")
    .replace(/(\s[~])(.*?)([~]\s)/g, " <del>$2</del> ").replace(/(^[~])(.*?)([~]$)/g, "<del>$2</del>")
    .replace(/(\s[~])(.*?)([~]$)/g, " <del>$2</del>").replace(/(^[~])(.*?)([~]\s$)/,"<del>$2</del> ")
    .replace(/(^[`]{3})(.*?)([`]{3}$)/g, '<span style="font-family:\'Lucida Console\', monospace"> $2 </span>')
    .replace(/(\s[`]{3})(.*?)([`]{3}\s)/g, '<span style="font-family:\'Lucida Console\', monospace"> $2 </span>')
    .replace(/(\s[`]{3})(.*?)([`]{3}$)/g, '<span style="font-family:\'Lucida Console\', monospace"> $2</span>')
    .replace(/([`]{3})(.*?)([`]{3}\s$)/g, '<span style="font-family:\'Lucida Console\', monospace">$2 </span>')
  }

export const invertColor = (hex = "#FFFFFF", bw = true, menuList) => {
    if (menuList) {
        return hex;
    }
    function padZero(str, len) {
        len = len || 2;
        var zeros = new Array(len).join("0");
        return (zeros + str).slice(-len);
    }
    //https://stackoverflow.com/questions/35969656
    if (hex.indexOf("#") === 0) {
        hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
        throw new Error("Invalid HEX color.");
    }
    var r = parseInt(hex.slice(0, 2), 16),
        g = parseInt(hex.slice(2, 4), 16),
        b = parseInt(hex.slice(4, 6), 16);

    if (bw) {
        // http://stackoverflow.com/a/3943023/112731
        return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? "#0F120F" : "#F1F2EB";
    }
};

// checkMobile returns true if it's a mobile device
export const checkMobile = () => {

    if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
            navigator.userAgent
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            navigator.userAgent.substr(0, 4)
        )
    ) {
        return true;
    }
    return false;
};

export const isIOS = () => {
    // Tests whether userAgent has iPhone/iPad/iPod string in it
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

// Check if its a windows os device (required for avoiding scrollbars on this OS)
export const windowsOS = function () {
    /*search returns -1 if ther's no conincidence, 
    we add one to get the falsy value, then double negation to get the boolean value */
    return !!(window.navigator.userAgent.search(/Windows/) + 1)
}